<template>
  <div class="page-visit">
    <crm-panel :title="'拜访列表'">
      <div class="page-buttons">
        <crm-button
          v-if="auth.visitAdd && auth.visitAdd.toggleStatus"
          :buttonType="'secondary'"
          :text="'新增'"
          @click="handleAddVisit()"
        >
        </crm-button>
        <crm-button
          v-if="auth.visitExport && auth.visitExport.toggleStatus"
          :buttonType="'plain'"
          :text="'导出'"
          :disabled="isDownload"
          @click="handleVisitExport()"
        >
        </crm-button>
      </div>
      <!-- 搜索条 -->
      <div class="mt20">
        <el-form ref="searchForm" :model="searchForm" :inline="true">
          <el-form-item label="">
            <el-select
              clearable
              v-model="searchForm.visitType"
              placeholder="拜访方式"
            >
              <el-option
                :key="item.uid"
                v-for="item in visitTypeList"
                :label="item.name"
                :value="item.uid"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <el-select
              clearable
              v-model="searchForm.isFinished"
              placeholder="是否完成"
            >
              <we-yes-or-no-options v-once />
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <el-select
              clearable
              v-model="searchForm.teamLabel"
              placeholder="用户角色"
            >
              <el-option label="全部" :value="0"></el-option>
              <we-search-select-type-options />
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <crm-cascader
              :value="searchForm.teamIds"
              :options="visitTeamList"
              placeholder="团队"
              clearable
              :props="{ multiple: true, checkStrictly: true }"
              :show-all-levels="false"
              @change="changeParentTeam"
            >
            </crm-cascader>
          </el-form-item>
          <el-form-item label="">
            <el-date-picker
              v-model="searchForm.time"
              :editable="false"
              type="daterange"
              value-format="yyyy-MM-dd"
              range-separator="至"
              align="right"
              start-placeholder="拜访日期始"
              end-placeholder="拜访日期止"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="">
            <el-input
              placeholder="根据名称查询"
              v-model="searchForm.salesmanName"
              class="input-with-select"
            >
              <el-select v-model="searchNameType" slot="prepend">
                <el-option label="业务员" :value="1"></el-option>
              </el-select>
              <i
                slot="suffix"
                class="el-input__icon el-icon-search"
                @click="handleSearch"
                style="cursor: pointer"
              ></i>
            </el-input>
          </el-form-item>
        </el-form>
      </div>
      <!-- 拜访记录列表 -->
      <el-table
        :data="visitList.results"
        border
        v-loading="loading"
        height="100%"
        style="width: 100%"
      >
        <el-table-column
          show-overflow-tooltip
          width="150"
          prop="visitObject"
          label="拜访对象"
          align="left"
          fixed="left"
        >
          <template slot-scope="{ row }">
            <span v-if="row.visitObject === 1">
              <span class="label-cus">客户</span>
              {{ row.customerName }}
            </span>
            <span v-if="row.visitObject === 2">
              <span class="label-busi">商机</span>
              {{ row.businessName }}
            </span>
            <span v-if="row.visitObject === 3">
              <span class="label-clue">线索</span>
              {{ row.cluesName }}
            </span>
            <span v-if="row.visitObject === 4">
              <span class="label-cus">客户</span>
              {{ row.customerName }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          width="150"
          prop="customerName"
          align="center"
          show-overflow-tooltip
          label="客户"
        >
          <template slot-scope="{ row }">
            <span v-if="row.customerType === 2">
              {{ row.customerName }}- {{ row.hospitalName }}-
              {{ row.hospDeptName }}
            </span>
            <span v-else>
              {{ row.customerName }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          width="100"
          prop="contactName"
          align="center"
          label="联系人"
        >
        </el-table-column>
        <el-table-column
          width="150"
          prop="visitDateStr"
          align="center"
          label="拜访时间"
        >
        </el-table-column>
        <el-table-column prop="visitTypeName" align="center" label="拜访方式">
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          width="200"
          prop="visitAim"
          align="center"
          label="拜访事宜"
        >
        </el-table-column>
        <el-table-column
          prop="isFinished"
          width="80"
          align="center"
          label="是否完成"
        >
          <template slot-scope="scope">
            {{ scope.row.isFinished | isFinishedMap }}
          </template>
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          width="200"
          prop="visitNote"
          align="center"
          label="拜访结果"
        >
        </el-table-column>

        <el-table-column
          width="80"
          prop="fileRecords"
          align="center"
          label="图片"
        >
          <template slot-scope="{ row }">
            <span
              v-if="row.fileRecords !== null && row.fileRecords.length !== 0"
            >
              <el-link @click="handleDetailShow(row.fileRecords)" type="primary"
                >查看
              </el-link>
            </span>
            <span v-else>
              <el-link type="info">无 </el-link>
            </span>
          </template>
        </el-table-column>
        <el-table-column
          width="80"
          prop="salesmanName"
          align="center"
          label="业务员"
        >
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          width="120"
          prop="teamName"
          align="center"
          label="团队"
        >
        </el-table-column>
        <el-table-column
          prop="gmtCreatedStr"
          width="200"
          align="center"
          label="创建时间"
        >
        </el-table-column>
        <el-table-column fixed="right" width="100" label="操作" align="center">
          <template slot-scope="scope">
            <el-button
              v-if="auth.visitUpdate && auth.visitUpdate.toggleStatus"
              @click="handleUpdateVisit(scope)"
              type="text"
              size="small"
            >
              编辑
            </el-button>
            <el-button
              v-if="auth.visitDelete && auth.visitDelete.toggleStatus"
              @click="handleDelete(scope)"
              type="text"
              size="small"
            >
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 拜访记录列表分页 -->
      <div class="pageination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="searchForm.pageNumber"
          :page-sizes="[10, 20, 50]"
          :page-size="searchForm.pageSize"
          layout="total, sizes, prev, pager, next"
          :total="visitList.totalCount"
        >
        </el-pagination>
      </div>
    </crm-panel>

    <!-- 新增 -->
    <add-visit
      v-show="isAddVisitVisible"
      :visible="isAddVisitVisible"
      @close="isAddVisitVisible = false"
      @success="handleSearch"
    >
    </add-visit>

    <!-- 编辑 -->
    <edit-visit
      v-show="isEditVisitVisible"
      :visible="isEditVisitVisible"
      :detail="detail"
      @close="isEditVisitVisible = false"
      @success="handleSearch"
    >
    </edit-visit>

    <!-- 图片详情弹窗 :title="拜访图片查看"-->
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="30%">
      <ul class="dialog-list-container">
        <li class="dialog-list-item">
          <div class="demo-image__lazy">
            <el-image
              v-for="url in dialogUrls"
              :key="url"
              :src="url"
              lazy
            ></el-image>
          </div>
        </li>
      </ul>
      <span slot="footer" class="dialog-footer">
        <crm-button :text="'确定'" @click="dialogVisible = false"></crm-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import config from '~config';
import { newDownloadByUrl } from '@/scripts/utils';
import WeYesOrNoOptions from '~component/base/yes-or-no-options';
import WeSearchSelectTypeOptions from '~component/business/visit/visit-select-type-options';
import crmPanel from '@/components/base/crmPanel';
import crmButton from '@/components/base/crmButton';
import CrmCascader from '@/components/base/crmCascader';
import AddVisit from '~component/business/visit/addVisit';
import EditVisit from '~component/business/visit/editVisit';
import api from '@/services/api/visit/index.js';

export default {
  components: {
    WeYesOrNoOptions,
    WeSearchSelectTypeOptions,
    crmPanel,
    crmButton,
    CrmCascader,
    AddVisit,
    EditVisit,
  },
  filters: {
    isFinishedMap(val) {
      if (val === 0) {
        return '未完成';
      }
      return '完成';
    },
  },
  data() {
    return {
      isDownload: false,
      loading: false,
      searchForm: {
        userAccount: '',
        salesmanName: '',
        teamIds: '',
        teamLabel: null,
        visitType: null,
        time: [],
        isFinished: null,
        pageNumber: 1,
        pageSize: 10,
      },
      dialogVisible: false,
      dialogTitle: '拜访图片查看',
      dialogUrls: [],
      detail: {},
      isAddVisitVisible: false,
      isEditVisitVisible: false,
      searchNameType: 1,
      searchName: '',
    };
  },
  computed: {
    ...mapGetters({
      auth: 'authority/visitAuth',
      userInfo: 'authority/userInfo',
      visitList: 'visit/visitList',
      visitDetail: 'visit/visitDetail',
      visitTypeList: 'visit/visitTypeList',
      visitTeams: 'visit/visitTeams',
    }),
    visitTeamList() {
      let teamArr = [];
      teamArr = JSON.parse(JSON.stringify([this.visitTeams]));
      this.deleteEmptyChild(teamArr);
      return teamArr;
    },
  },
  watch: {
    'searchForm.teamLabel': {
      handler: 'handleSearch',
    },
    'searchForm.teamIds': {
      handler: 'handleSearch',
    },
    'searchForm.time': {
      handler: 'handleSearch',
    },
    'searchForm.visitType': {
      handler: 'handleSearch',
    },
    'searchForm.isFinished': {
      handler: 'handleSearch',
    },
  },
  created() {
    if (JSON.stringify(this.$route.params) !== '{}') {
      this.searchForm.time = this.$route.params.time
        ? this.$route.params.time
        : [];
    }
    this.getVisitType({
      pageNumber: this.searchForm.pageNumber,
      pageSize: this.searchForm.pageSize,
      code: 'category_visit_type',
    });
    this.getVisitTeams();
    this.searchForm.teamIds = [this.userInfo.teamId];
  },
  methods: {
    ...mapActions({
      getVisitList: 'visit/getVisitList',
      getVisitDetail: 'visit/getVisitDetail',
      getVisitType: 'visit/getVisitType',
      getVisitTeams: 'visit/getVisitTeams',
      handleVisitExport: 'visit/handleVisitExport',
      deleteHandleVisit: 'visit/deleteHandleVisit',
    }),
    deleteEmptyChild(arr) {
      arr.forEach((item) => {
        if (!item.children || item.children.length <= 0) {
          delete item.children;
        } else {
          this.deleteEmptyChild(item.children);
        }
      });
    },
    changeParentTeam(teamInfo) {
      if (teamInfo.type && teamInfo.type === 'multiple') {
        this.searchForm.teamIds = teamInfo.value;
      } else {
        this.searchForm.teamIds = teamInfo[teamInfo.length - 1];
      }
    },
    handleSearch() {
      this.searchForm.pageNumber = 1;
      this.getVisitData();
    },
    getVisitData() {
      this.loading = true;
      Object.keys(this.searchForm).forEach((key) => {
        if (key !== 'time' && this.searchForm[key] === '') {
          this.searchForm[key] = null;
        }
      });
      if (this.searchForm.time === null) this.searchForm.time = [];
      const { time, ...otherParams } = this.searchForm;
      this.getVisitList({
        ...otherParams,
        startDateStr: this.searchForm.time[0],
        endDateStr: this.searchForm.time[1],
      }).finally(() => {
        this.loading = false;
      });
    },
    // 分页 每页显示条数
    handleSizeChange(val) {
      this.searchForm.pageSize = val;
      this.searchForm.pageNumber = 1;

      this.getVisitData();
    },
    // 分页，当前页改变
    handleCurrentChange(val) {
      this.searchForm.pageNumber = val;
      this.getVisitData();
    },
    // 新增
    handleAddVisit() {
      this.isAddVisitVisible = true;
    },
    // 编辑
    handleUpdateVisit(scope) {
      Promise.all([this.getVisitDetail({ id: scope.row.id })]).then(() => {
        const nextForm = this.$_.pick(this.visitDetail, [
          'id',
          'visitObject',
          'isFinished',
          'customerId',
          'contactId',
          'fileRecords',
          'customerName',
          'customerType',
          'businessId',
          'businessName',
          'cluesId',
          'cluesName',
          'visitDateStr',
          'visitNote',
          'visitAim',
          'visitType',
          'salesmanCode',
        ]);
        if (nextForm.visitObject === 1) {
          nextForm.visitObjectId = nextForm.customerId;
          // 客户
          nextForm.customVisible = true;
          if (nextForm.customerType === 2) {
            nextForm.contactVisible = false;
          } else {
            nextForm.contactVisible = true;
          }

          // 商机下拉展示
          nextForm.buisVisible = false;
          // 线索下拉展示
          nextForm.cluesVisible = false;
        } else if (nextForm.visitObject === 2) {
          nextForm.visitObjectId = nextForm.businessId;
          nextForm.customVisible = false;
          nextForm.contactVisible = true;
          // 商机下拉展示
          nextForm.buisVisible = true;
          // 线索下拉展示
          nextForm.cluesVisible = false;
        } else if (nextForm.visitObject === 3) {
          nextForm.visitObjectId = nextForm.cluesId;
          nextForm.customVisible = false;
          nextForm.contactVisible = false;
          // 商机下拉展示
          nextForm.buisVisible = false;
          // 线索下拉展示
          nextForm.cluesVisible = true;
        }
        // 拜访结果影藏
        nextForm.visitNoteVisible = false;
        // 文件
        if (nextForm.fileRecords !== null && nextForm.fileRecords.length > 0) {
          nextForm.fileId = nextForm.fileRecords[0].id;
          nextForm.fileUrl = nextForm.fileRecords[0].fileUrl;
        }
        this.detail = nextForm;
        this.isEditVisitVisible = true;
      });
    },
    // 导出
    handleVisitExport() {
      const prevTime = new Date(this.searchForm.time[0]);
      const lastTime = new Date(this.searchForm.time[1]);
      if (this.searchForm.time.length < 2) {
        this.$message({
          type: 'error',
          message: '请选择一个月区间内的日期！',
        });
      } else if (
        prevTime.getDate() === 1
        && lastTime.getMonth() !== prevTime.getMonth()
      ) {
        this.$message({
          type: 'error',
          message: '仅能导出一个月数据，请重新选择日期！',
        });
      } else if (
        lastTime.getMonth() !== prevTime.getMonth()
        && lastTime.getDate() > prevTime.getDate() - 1
      ) {
        this.$message({
          type: 'error',
          message: '仅能导出一个月数据，请重新选择日期！',
        });
      } else {
        Object.keys(this.searchForm).forEach((key) => {
          if (this.searchForm[key] === '') {
            this.searchForm[key] = null;
          }
        });
        const { time, ...otherParams } = this.searchForm;
        const params = {
          ...otherParams,
          startDateStr: this.searchForm.time[0],
          endDateStr: this.searchForm.time[1],
        };
        this.notify = this.$notify({
          iconClass: 'el-icon-loading',
          title: '',
          message: '正在导出中，请稍后...',
          duration: 0,
          showClose: false,
        });
        this.isDownload = true;
        const url = `${config.api || ''}/api/visit/export`;
        newDownloadByUrl(url, 'post', params).finally(() => {
          this.notify.close();
          this.isDownload = false;
        });
      }
    },
    // 删除
    handleDelete(scope) {
      this.$confirm('是否确定删除拜访记录？', '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.deleteHandleVisit({
            id: scope.row.id,
          }).then(() => {
            this.$message({
              type: 'success',
              message: '删除成功!',
            });
            this.handleSearch();
          });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          });
        });
    },
    //  图片查看
    handleDetailShow(scope) {
      if (scope) {
        this.dialogUrls[0] = scope[0].fileUrl;
        this.dialogVisible = true;
      }
    },
  },
};
</script>

<style lang="less">
@import '~@/styles/var.less';
.page-visit {
  display: flex;
  flex: 1;
  width: 100%;
  overflow: hidden;
  .label-cus {
    background-color: rgba(50, 128, 252, 1);
    padding: 0 5px;
    color: #fff;
    border-radius: 4px;
  }
  .label-busi {
    background-color: rgba(3, 184, 207, 1);
    padding: 0 5px;
    color: #fff;
    border-radius: 4px;
  }
  .label-clue {
    background-color: rgba(134, 102, 184, 1);
    padding: 0 5px;
    color: #fff;
    border-radius: 4px;
  }
}
.el-tooltip__popper {
  width: 300px;
}
</style>
